const config = {
  state: {
    map_center: localStorage.getItem('config_map_center') || '',
  },
  mutations: {
    saveConfig(state, data) {
      Object.assign(state, data);
      if (data.map_center !== undefined) {
        localStorage.setItem('config_map_center', data.map_center);
      }
    },
  },
  actions: {
    saveConfig({ commit }, data) {
      commit('saveConfig', data);
    },
  },
}

export default config;
